import { render } from "./ApplyBank.vue?vue&type=template&id=fed272fc"
import script from "./ApplyBank.vue?vue&type=script&lang=js"
export * from "./ApplyBank.vue?vue&type=script&lang=js"

import "./ApplyBank.vue?vue&type=style&index=0&id=fed272fc&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__